import React, { useState } from 'react';
import { Script } from "gatsby"

import { sanitizeHtmlContent } from '../utils/utils'

export default function ContentInstagramFeed(props) {
  //console.log('ContentInstagramFeed - props', props);

  const {
    content
  } = props;

  //const textColor = props.text_color ? props.text_color : props.header_text_color ? props.header_text_color : null;

  const [loaded, setLoaded] = useState(false);

  const handleScriptLoad = () => {
    if (!loaded && window.instgrm) {
      window.instgrm.Embeds.process()
    }
    setLoaded(true)
  }
  
  return (
    <>
      {/* <style dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize([
          '#layout-wrapper a.ui.button.postUpSignUpButton {',
          '  color: '+ textColor +';',
          '  box-shadow: inset 0 0 0 2px '+ textColor +' !important;',
          '}',
          '#layout-wrapper a.ui.button.postUpSignUpButton:hover {',
          '  color: '+ props.header_background_color +' !important;',
          '  background: '+ textColor +' !important;',
          '}'
          ].join('\n'))
        }}>
      </style> */}
      <div className={'content-instagram-feed'}>
        {content && content.html ?
          <>
            <div dangerouslySetInnerHTML={{__html: sanitizeHtmlContent(content.html, {allowedTags: false, allowedAttributes: false, allowVulnerableTags: true})}}></div>
            <Script async src="https://www.instagram.com/embed.js" strategy="post-hydrate" onLoad={() => handleScriptLoad()}></Script>
          </>
        :
          null
        }
      </div>
    </>
  )
}
